import type {
  AdvancedSearchData,
  AdvancedSearchRequest,
  ReviewRequest
} from '@/models/interface/advancedSearch';
import type { ReviewDetail } from '@/models/interface/course';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class ScheduleService extends ApiFactory {
  constructor() {
    super('Schedule');
  }

  /**
   *  查詢課表
   */
  advancedSearch(params: AdvancedSearchRequest): Promise<ApiDataResponse<AdvancedSearchData>> {
    return super.post(`AdvancedSearch`, params);
  }
  /**
   *  確認下載扣打
   */
  checkDownloadQuota(classId: string): Promise<ApiDataResponse<string>> {
    return super.get(`CheckDownloadQuota?class_id=${classId}`);
  }
  /**
   *  播放、下載課程影片(執行扣堂)
   */
  playVideos(classId: string): Promise<ApiDataResponse<boolean>> {
    return super.postNoData(`PlayVideo?classId=${classId}`);
  }
  /**
   *  取得精選回顧影片(名師講堂 & 國高中課程)
   */
  getHighlightReview(params: ReviewRequest): Promise<ApiDataResponse<ReviewDetail[]>> {
    return super.get('GetHighlightReview', params);
  }
}
